import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { connectField, filterDOMProps } from 'uniforms';
const ListDel = (_a) => {
    var { className, disabled, name, parent, removeIcon } = _a, props = __rest(_a, ["className", "disabled", "name", "parent", "removeIcon"]);
    const fieldIndex = +name.slice(1 + name.lastIndexOf('.'));
    const limitNotReached = !disabled && !(parent.minCount >= parent.value.length);
    return (React.createElement("span", Object.assign({ className: classnames('badge badge-pill', className), onClick: () => limitNotReached &&
            parent.onChange([]
                .concat(parent.value.slice(0, fieldIndex))
                .concat(parent.value.slice(1 + fieldIndex))) }, filterDOMProps(props)), removeIcon));
};
ListDel.defaultProps = { removeIcon: React.createElement("i", { className: "octicon octicon-dash" }) };
export default connectField(ListDel, {
    includeParent: true,
    initialValue: false,
});
